export default __webpack_public_path__ + "static/media/ecom-business-icon.dc60ccf7.svg";